/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/

import { faCamera, IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import { EPGImageSliderItem } from '../../../app/shared/epg-image-slider/epg-image-slider.component';
import { getImageSliderFromTaskDatum } from '../../../app/shared/functions';
import { LocationModel, RecordBaseModel, WorkflowItemType } from '../record-base.model';

export class CameraRecord extends RecordBaseModel {
  itemIcon: IconDefinition = faCamera;
  itemData?: CameraRecordData;

  constructor(itemName: string, geolocation?: LocationModel, timestamp?: string) {
    super(itemName, WorkflowItemType.CAMERA, undefined, geolocation, timestamp);
  }

  fromJson(json: any): CameraRecord | undefined {
    let record = new CameraRecord(
      json.itemName.value,
      LocationModel.fromJson(json.geolocation),
      json.timestamp?.value
    );
    let recordData = Object.create(CameraRecordData.prototype);
    record.itemData = recordData.fromJson(json);

    return record;
  }
}

export class CameraRecordData {
  hintText: string;
  minAmount: number;
  maxAmount: number;
  images?: EPGImageSliderItem[];

  constructor(
    hintText: string,
    minAmount: number,
    maxAmount: number,
    images?: EPGImageSliderItem[]
  ) {
    this.hintText = hintText;
    this.minAmount = minAmount;
    this.maxAmount = maxAmount;
    this.images = images;
  }

  fromJson(json: any): CameraRecordData {
    const hintText = json.hintText?.value ?? '';
    const minAmount = json.minAmount?.value ?? 0;
    const maxAmount = json.maxAmount?.value ?? 25;
    let images: EPGImageSliderItem[] = [];
    for (const image of json.images?.value ?? []) {
      if (image.value.image) {
        images.push(getImageSliderFromTaskDatum(image.value.image));
      }
    }
    return new CameraRecordData(hintText, minAmount, maxAmount, images);
  }
}
